import { render, staticRenderFns } from "./invagingweeksum.vue?vue&type=template&id=9fae7140&scoped=true&"
import script from "./invagingweeksum.vue?vue&type=script&lang=js&"
export * from "./invagingweeksum.vue?vue&type=script&lang=js&"
import style0 from "./invagingweeksum.vue?vue&type=style&index=0&id=9fae7140&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fae7140",
  null
  
)

export default component.exports